(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oitc-mount-rushmore"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(scope){
    scope.querySelectorAll('[data-oitc-motion]:not([data-motion-ready])').forEach(function(banner){
      banner.dataset.motionReady='true';
      var button=banner.querySelector('.oitc-vj__motion');
      button.addEventListener('click',function(){var paused=banner.dataset.paused!=='true';banner.dataset.paused=String(paused);button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?'Resume moving clouds':'Pause moving clouds');button.textContent=paused?'Resume clouds':'Pause clouds';});
      if('IntersectionObserver' in window){var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){banner.dataset.offscreen=String(!entry.isIntersecting);});},{rootMargin:'100px'});observer.observe(banner);}
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
